(function () {
  const bundleImage =
    "https://cdn.shopify.com/s/files/1/0636/2608/4604/files/ChatGPTImageOct6_2026_05_18_52PM.png?v=1791289170";

  const bundleUrl = "/products/twist-curb-set";

  const targetHandles = [
    "silver-twisted-chain-20",
    "curbed-micro-bracelet-copy",
    "curbed-micro-bracelet"
  ];

  function addUpsell() {
    const path = window.location.pathname;
    const currentHandle = path.match(/\/products\/([^\/]+)/)?.[1];

    if (!currentHandle || !targetHandles.includes(currentHandle)) return;

    if (document.querySelector(".lvrg-bundle-upsell")) return;

    const productForm =
      document.querySelector(".product-form__buttons") ||
      document.querySelector(".product-form") ||
      document.querySelector("product-form") ||
      document.querySelector('form[action*="/cart/add"]');

    if (!productForm) return;

    const box = document.createElement("div");
    box.className = "lvrg-bundle-upsell";

    box.innerHTML = `
      <img
        class="lvrg-bundle-upsell__image"
        src="${bundleImage}"
        alt="Twist & Curb Set"
      >

      <div class="lvrg-bundle-upsell__content">
        <p class="lvrg-bundle-upsell__title">Complete the look</p>

        <p class="lvrg-bundle-upsell__text">
          Get the Twist & Curb Set with our Micro Curbed Bracelet and Twisted Chain together for Rs. 2,200. Save Rs. 300 when you get the set.
        </p>

        <a
          class="lvrg-bundle-upsell__link"
          href="${bundleUrl}"
        >
          Shop the set →
        </a>
      </div>
    `;

    productForm.parentNode.insertBefore(box, productForm);
  }

  addUpsell();

  document.addEventListener("DOMContentLoaded", addUpsell);

  setTimeout(addUpsell, 500);
  setTimeout(addUpsell, 1500);
  setTimeout(addUpsell, 3000);

  const observer = new MutationObserver(addUpsell);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();